import firebase from 'firebase/app'
import 'firebase/auth';
import 'firebase/functions';


const config = {
    apiKey: "AIzaSyC6RbECPFG7_-GQcjfzQi3hSwaZKHpIs78",
    authDomain: "horas-d96c5.firebaseapp.com",
    databaseURL: "https://horas-d96c5.firebaseio.com",
    projectId: "horas-d96c5",
    storageBucket: "horas-d96c5.appspot.com",
    messagingSenderId: "81672175068"
  };

if (!firebase.apps.length) {
        firebase.initializeApp(config);
}

const auth = firebase.auth();

const functions = firebase.functions()

export { auth, functions };



// WEBPACK FOOTER //
// ./src/firebase/firebase.js